// QR helpers for asset labels. Uses the `qrcode` package (added to package.json).
// Dynamic-imported so a page never hard-crashes if the dep hasn't been installed yet.
let _qr = null;
async function lib() {
  if (_qr) return _qr;
  try { _qr = (await import("qrcode")).default; } catch { _qr = null; }
  return _qr;
}

// Returns a PNG data URL for the given payload (the asset tag), or null.
export async function qrDataUrl(text, opts = {}) {
  const q = await lib();
  if (!q) return null;
  try {
    return await q.toDataURL(String(text), { width: opts.width || 220, margin: 1, errorCorrectionLevel: "M" });
  } catch { return null; }
}

// Open a print-ready window with one or more labels (tag + QR + name).
export async function printLabels(assets, instituteName = "") {
  const items = await Promise.all(
    (Array.isArray(assets) ? assets : [assets]).map(async (a) => ({
      tag: a.asset_tag, name: a.name, url: await qrDataUrl(a.asset_tag, { width: 240 }),
    }))
  );
  const cells = items.map((it) => `
    <div class="label">
      ${it.url ? `<img src="${it.url}" alt="${it.tag}"/>` : `<div class="noqr">QR unavailable</div>`}
      <div class="tag">${it.tag}</div>
      <div class="name">${(it.name || "").replace(/</g, "&lt;")}</div>
      ${instituteName ? `<div class="inst">${instituteName.replace(/</g, "&lt;")}</div>` : ""}
    </div>`).join("");
  const w = window.open("", "_blank", "width=760,height=560");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>Asset labels</title>
    <style>
      * { box-sizing: border-box; }
      body { font-family: Inter, Arial, sans-serif; margin: 16px; }
      .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 12px; }
      .label { border: 1px solid #d7deea; border-radius: 10px; padding: 10px; text-align: center; page-break-inside: avoid; }
      .label img { width: 130px; height: 130px; }
      .noqr { width: 130px; height: 130px; display: grid; place-items: center; color: #99a; font-size: 11px; margin: 0 auto; }
      .tag { font-family: "IBM Plex Mono", monospace; font-weight: 700; font-size: 13px; margin-top: 6px; }
      .name { font-size: 11px; color: #556; margin-top: 2px; }
      .inst { font-size: 9px; color: #99a; text-transform: uppercase; letter-spacing: .12em; margin-top: 4px; }
      @media print { body { margin: 8mm; } }
    </style></head>
    <body><div class="grid">${cells}</div>
    <script>window.onload = () => setTimeout(() => window.print(), 250);</script>
    </body></html>`);
  w.document.close();
}
